import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import getRoutes from "routes";

export default function Login() {
  const switchRoutes = (
    <Switch>
      {getRoutes(1, "")
        .filter((x) => x.layout === "/login")
        .map((x, idx) => (
          <Route path={x.layout} component={x.component} key={idx} />
        ))}
      <Redirect from="/" to="/login" />
    </Switch>
  );

  // initialize and destroy the PerfectScrollbar plugin
  return (
    <div>
      {window.location.pathname !== "/login" ? (
        <div>
          <div>{switchRoutes}</div>
        </div>
      ) : (
        <div>{switchRoutes}</div>
      )}
    </div>
  );
}
